import { drupalApiGet } from "./api";
import { FilterMetadataApiReturn } from "./types";

export const fetchProviderFilterMetadata = async (options?: RequestInit): Promise<FilterMetadataApiReturn> => {
    return drupalApiGet<FilterMetadataApiReturn>("wpcr/api/filters-metadata", options);
};
